module.exports = require('./event-emitter')["default"];